import styled, { css } from 'styled-components';

import { H1, Clickable, Text, mediaQuery } from '@catalyze/ui';

export const Container = styled.section``;

export const EDMSContainer = styled.div`
    column-gap: 2rem;
    row-gap: 1.5rem;
    display: grid;
    grid-auto-rows: minmax(min-content, max-content);
    width: 40rem;
    grid-template-columns: 1fr 1fr;
    ${mediaQuery(
        4,
        css`
            grid-template-columns: 1fr 1fr 1fr;
            width: 40rem;
        `
    )}
`;

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 27rem;

    .tooltip {
        position: relative;
        display: inline-block;
    }

    /* Tooltip text */
    .tooltip .tooltiptext {
        font-weight: 400;
        font-size: 0.875em;
        visibility: hidden;
        background-color: #fff;
        color: #292929;
        text-align: center;
        padding: 5px 0;
        border-radius: 6px;

        /* Position the tooltip text - see examples below! */
        position: absolute;
        z-index: 1;
        width: 320px;
        bottom: 120%;
        left: 50%;
        margin-left: -60px;
    }

    /* Show the tooltip text when you mouse over the tooltip container */
    .tooltip:hover .tooltiptext {
        visibility: visible;
    }
`;

export const SectionTitle = styled(H1)`
    grid-area: edm;
    font-weight: 700;
`;

export const StyledButton = styled(Clickable)`
    font-weight: 700;

    & > svg {
        display: inline-block;
        width: 1.5rem;
        vertical-align: bottom;
        margin-right: 0.25rem;
    }
`;

export const EmptyState = styled(Text)`
    margin-top: 1rem;
    color: ${({ theme }) => theme.colors.fontTertiary};
`;
